/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactregisterednoticetimesaved4Inputs */

const en_artifactregisterednoticetimesaved4 = /** @type {(inputs: Artifactregisterednoticetimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves drafting CC art. 808 deadline language and registered-mail routing`)
};

const pt_artifactregisterednoticetimesaved4 = /** @type {(inputs: Artifactregisterednoticetimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poupa a redação da linguagem de prazo do art. 808.º do CC e o encaminhamento por correio registado`)
};

/**
* | output |
* | --- |
* | "Saves drafting CC art. 808 deadline language and registered-mail routing" |
*
* @param {Artifactregisterednoticetimesaved4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactregisterednoticetimesaved4 = /** @type {((inputs?: Artifactregisterednoticetimesaved4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactregisterednoticetimesaved4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactregisterednoticetimesaved4(inputs)
	return pt_artifactregisterednoticetimesaved4(inputs)
});
export { artifactregisterednoticetimesaved4 as "artifactRegisteredNoticeTimeSaved" }